import { useUserInformation } from '@hooks/useUserInformation';
import { useAuthContext } from '@services/Auth';
import { ClientType } from '@services/Auth';
import { AssistantType } from '@src/types/attribution';
import { UserInformation } from '@src/types/auth';

const getIsCorporatePartner = (
  user?: Nullable<UserInformation>,
  client?: Nullable<ClientType>
) =>
  client === ClientType.OktaExternal &&
  user?.type === AssistantType.PARTNER &&
  Boolean(user?.isCorporate);

const getIsPartner = (
  user?: Nullable<UserInformation>,
  client?: Nullable<ClientType>
) =>
  client === ClientType.OktaExternal &&
  user?.type === AssistantType.PARTNER &&
  !getIsCorporatePartner(user, client);

const getIsSales = (client?: Nullable<ClientType>) =>
  client === ClientType.OktaInternal;

export const useUserRole = () => {
  const { activeClient } = useAuthContext();
  const userInformation = useUserInformation();
  // if there is an an active client the user is authenticated as
  // a partner or sales, so wait for the profile to be returned to
  // ensure `isCorporate` is accurate
  const loading = Boolean(activeClient && !userInformation);

  return {
    loading,
    isPartner: loading
      ? undefined
      : getIsPartner(userInformation, activeClient),
    isCorporatePartner: loading
      ? undefined
      : getIsCorporatePartner(userInformation, activeClient),
    isSales: loading ? undefined : getIsSales(activeClient),
  };
};
